import { getPrimaryTracker } from 'usage-tracker-container';

const getUsageTracker = function getUsageTracker() {
  try {
    return getPrimaryTracker();
  } catch (err) {
    return {
      track: () => {
        throw new Error('UsageTracker .track called before setPrimaryTracker');
      },
      setProperties: () => {
        throw new Error('UsageTracker .setProperties called before setPrimaryTracker');
      }
    };
  }
};

getUsageTracker.track = () => {
  throw new Error('Invalid usage of tracker: Call getUsageTracker().track(), not getUsageTracker.track()');
};

export default getUsageTracker;